import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import BlogContentEditor from '../../components/AdminBlogPostsPage/BlogContentEditor';

const BlogPostForm = forwardRef(({ 
  formData, 
  errors, 
  handleChange, 
  handleFileChange, 
  categories,
  onContentImagesChange,
  existingContentImages
}, ref) => {
  const contentEditorRef = useRef(null);
  const [contentImages, setContentImages] = useState([]);

  const handleImageClick = () => {
    document.getElementById('main-image-input').click();
  };

  const handleContentImagesChange = (images) => {
    setContentImages(images);
    
    // Notificar al componente padre sobre el cambio en las imágenes del contenido
    if (onContentImagesChange) {
      onContentImagesChange(images);
    }
  };

  // Función para obtener las imágenes del contenido como archivos
  const getContentImages = () => {
    if (contentEditorRef.current) {
      return contentEditorRef.current.getContentImages();
    }
    return [];
  };

  // Exponer la función al componente padre usando useImperativeHandle
  useImperativeHandle(ref, () => ({
    getContentImages
  }));

  return (
    <div className="blog-modal-content">
      {/* Left Column - Image Upload and Basic Info */}
      <div className="blog-modal-left-column">
        {/* Main Image Upload */}
        
        <div className="blog-modal-left-column-image">
          <label className="blog-field-label">Main Image</label>
          <div className="blog-image-upload-container">
            <div 
              className="blog-image-placeholder"
              onClick={handleImageClick}
            >
            {formData.main_image ? (
              <img 
                src={formData.main_image instanceof File ? URL.createObjectURL(formData.main_image) : formData.main_image} 
                  alt="Main Image" 
              />
            ) : (
                <div className="blog-image-upload-text">
                  Click to upload main image
              </div>
            )}
          </div>
          <input
            type="file"
            name="main_image"
            accept="image/*"
            id="main-image-input"
            onChange={handleFileChange}
            style={{ display: 'none' }}
            className={errors.main_image ? 'error' : ''}
          />
            <div className="blog-image-specs">
            Main Image: 1200x630 pixels - Max 2MB
            </div>
            {errors.main_image && (
              <div className="blog-form-field">
                <div className="error-message">{errors.main_image}</div>
          </div>
            )}
          </div>
        </div>
        <div className="blog-modal-left-column-form">
          {/* Basic Form Fields */}
          <div className="blog-form-field">
            <label className="blog-field-label">Title</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Post Title*"
              className={errors.title ? 'error' : ''}
            />
            {errors.title && (
              <div className="error-message">{errors.title}</div>
            )}
          </div>
          <div className="blog-form-field">
            <label className="blog-field-label">Category</label>
            <select
              name="category_id"
              value={formData.category_id}
              onChange={handleChange}
              className={errors.category_id ? 'error' : ''}
            >
              <option value="">Select Category</option>
              {categories && categories.map(category => (
                <option key={category.id} value={category.id}>{category.name}</option>
              ))}
            </select>
            {errors.category_id && (
              <div className="error-message">{errors.category_id}</div>
            )}
          </div>

          <div className="blog-form-field">
            <label className="blog-field-label">Status</label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className={errors.status ? 'error' : ''}
            >
              <option value="draft">Draft</option>
              <option value="published">Published</option>
              
            </select>
            {errors.status && (
              <div className="error-message">{errors.status}</div>
            )}
          </div>
        </div>
      </div>

      {/* Right Column - Content Editor */}
      <div className="blog-modal-right-column">
        <BlogContentEditor
          ref={contentEditorRef}
          content={formData.content}
          onChange={(newContent) => {
            console.log('🔍 [BlogPostForm] BlogContentEditor onChange llamado con:', newContent);
            console.log('🔍 [BlogPostForm] Tipo de newContent:', typeof newContent);
            console.log('🔍 [BlogPostForm] Es array?', Array.isArray(newContent));
            
            // Llamar directamente a handleChange con los parámetros correctos
            handleChange({ target: { name: 'content', value: newContent } });
          }}
          onImagesChange={handleContentImagesChange}
          existingContentImages={existingContentImages}
        />
        {errors.content && (
          <div className="blog-form-field">
            <div className="error-message">{errors.content}</div>
          </div>
        )}
      </div>
    </div>
  );
});

BlogPostForm.displayName = 'BlogPostForm';

export default BlogPostForm; 